export default [
  { name: "Name", value: "name" },
  { name: "Street", value: "street" },
  { name: "City", value: "city" },
  { name: "State", value: "state" },
  { name: "Zip Code", value: "zipcode" },
  { name: "Phone", value: "phone" }, 
  { name: "Email", value: "email" },
  
];
